import { defaultTo, find, pathEq, pipe } from 'ramda';

import coutryList from './list.json';

// eslint-disable-next-line import/prefer-default-export
export const getCountryByCode = (code) =>
  pipe(find(pathEq(['number'], code)), defaultTo({}))(coutryList);
